import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/doItYourself/blog-do-it-yourself-001.jpg";
// import img002 from "../../images/doItYourself/blog-do-it-yourself-001.jpg";
// import img003 from "../../images/doItYourself/blog-do-it-yourself-001.jpg";
// import img004 from "../../images/doItYourself/blog-do-it-yourself-001.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const DoItYourselfData = {
  title: "Do-It-Yourself Paver Installation",
  image: img001,
  destination: "/blog/do-it-yourself-paver-installation",
  date: "November 10, 2010",
  categories: ["blog", "driveways", "installation", "paving-stones"],
};

const DoItYourself = () => {
  const blog = [DoItYourselfData];
  return (
    <>
      <SEO
        title="8 Steps for DIY Paver Installation "
        description="Deciding to lay paving stones yourself is not something to be entered into lightly. Follow these 8 steps to install pavers yourself properly!"
        profileURL={
          "https://www.pacificpavingstone.com/blog/do-it-yourself-paver-installation"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/do-it-yourself-paver-installation",
          headline: "8 Steps for DIY Paver Installation",
          description:
            "Deciding to lay paving stones yourself is not something to be entered into lightly. Follow these 8 steps to install pavers yourself properly!",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-do-it-yourself-001.f3d5a0b7.jpg",
          },
          datePublished: "2010-11-10",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Deciding to lay{" "}
              <span className="text-blue">paving stones yourself</span> is not
              something to be entered into lightly. A professionally trained
              crew with all the proper machinery and tools necessary for the
              installation typically can install a paving stone driveway or
              patio pavers in a matter of days. For the do-it-yourselfer, this
              could turn into weeks.
            </p>
            <h3>PAVING STONES</h3>
            <p>
              Paving stones are pavers made from either concrete or clay. They
              are set in sand rather than mortar. Mortar binds them together and
              prevents motion. Setting pavers in sand provides some mobility and
              thus cracking seldom occurs. This also makes them earthquake
              resistant and allows easy repair by simply removing and replacing
              a stone. Driveway pavers our perform mortar set stones and brick
              in durability, strength and flexibility (the ability to resist
              cracking).
            </p>
            <h4>Driveway and Patio Planning</h4>
            <p>
              There are many requirements that must be considered when planning
              to pave your patio, driveway, pool areas, etc. The specific
              criteria may not necessarily agree with local codes and
              regulations. If no local codes or regulations exist, refer to the
              minimum standards of the F.H.A. or V.A. requirements.
            </p>
            <h4>Paver Installation Do-It-Yourself</h4>
            <p>
              For a simple square or rectangle paving stone patio, you can
              follow the basic installation steps below. However, we highly
              suggest you contact a professional if you have anything more
              complicated in mind, especially if it requires stone cutting for
              intricate patterns.
            </p>
            <ul>
              <li>
                <p>
                  <span className="text-blue">Step 1:</span> Demolition – remove
                  old driveway or patio. Go down a minimum of 7″.
                </p>
              </li>

              <li>
                <p>
                  <span className="text-blue">Step 2:</span> Compact the sub
                  base – the dirt that will be directly under the base material.
                </p>
              </li>

              <li>
                <p>
                  <span className="text-blue">Step 3:</span> Install the base –
                  Class II Road Base is used. This is composed of various sizes
                  of gravel. See the picture of the sieve. A sieve is used to
                  test soil and base material. There is a wire mesh at the
                  bottom of each pan. At the top the mesh will allow 3/4 ” rock
                  through, the next one down will be 1/2 “, then 1/4 ” all the
                  way to the last pan that will allow only “fines”. A fine is
                  described as a particle that can pass through a #200 mesh. A
                  #200 mesh has 350 openings per square inch. This is actually
                  like a fine cloth. Water will not pass through a #200 mesh but
                  fines will. So these particles are very small!{" "}
                </p>
                <p>
                  Certified base has correct quantities of all the above sizes
                  so that it will compact to at least 95%. Imagine stepping on a
                  field of marbles – they would move. Or even stepping in sand
                  at the beach – not very firm. That’s because they are all the
                  same size. Since certified base comes with the right
                  proportions, the end result will be a very firm sturdy base.
                </p>
                <p>
                  The base should be compacted and at least twice as shown
                  below.
                </p>
                <p>1st recommended compacting pattern for compacting pavers</p>
                <p>2nd recommended compacting pattern for compacting pavers</p>
                <p>
                  To achieve the desired level of compaction, 95% base should be
                  compacted in “lifts”. A lift is a layer of material, base, or
                  dirt to be compacted. For base, the lifts should be no more
                  than 4″ thick. The compactor should be a very heavy duty
                  machine that produces a minimum of 5000 psi. Smaller machines
                  will never achieve the desired 95% compaction.
                </p>
              </li>

              <li>
                <p>
                  <span className="text-blue">Step 4:</span> The next step is
                  the sand bedding. (this is angular sand as mentioned above) -a
                  one inch sand bed is screeded in place, the pavers are laid on
                  top.
                </p>
              </li>

              <li>
                <p>
                  <span className="text-blue">Step 5:</span> Cutting the pavers
                  – the edges are cute with a dry saw and each fit precisely in
                  place.
                </p>
              </li>

              <li>
                <p>
                  <span className="text-blue">Step 6:</span> Install restraints
                  – Since pavers are set in sand, they need to be held together
                  by something. What holds them together is the borders or the
                  outside perimeter. This outside edge is referred to as a
                  restraint. Once they are finally held in place, they can not
                  move yet the entire surface is flexible. As compared to a
                  poured in place concrete surface which is rigid. As a word,
                  flexible, best describes the interlocking concrete surface
                  whereas rigid would describe a concrete surface.{" "}
                </p>
                <p>There are several types of restraints as shown below.</p>
              </li>

              <li>
                <p>
                  <span className="text-blue">Step 7:</span> Compacting the
                  pavers – Once the restraints are in place, the next step is to
                  compact the pavers in doing so, the pavers are pushed into the
                  bedding sand and the sand is forced up between the pavers.
                </p>
              </li>
              <li>
                <p>
                  <span className="text-blue">Step 8:</span> Sand between the
                  pavers – Once this is done more sand, either the same bedding
                  sand or joint sand that comes in bags, is swept between the
                  pavers and the pavers are compacted again. In using a
                  vibrating plate compactor, all the joints between the pavers
                  are filled.
                </p>
              </li>
            </ul>
            <p>
              If you would like a consultation please contact us and one of our
              experienced designers will personally meet with you to plan and
              design exactly the paver installation you want. They will help you
              select the paving stone (pavers) colors, shapes, and style that
              will instantly increase your home’s value and curb appeal. And for
              much less than our competitors!
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(DoItYourself);
